/**
 *  Common functions for Session management
 *  Include as mixin: [SessionManageMixin] in all pages ( App.vue )just once
 *
 */

 import API from "@/api/index";
 import _ from "lodash";
 import { PAGES } from "@/utils/index";
 import { mapState, mapMutations } from "vuex";
 import { CATEGORIES_TYPES, } from '@/utils';
 
 export default {
   data() {
     return {
       //corporation: null,
       //corporationInfo: {},
       //isLoggedIn: false,
       //user: null,
       // Modals data
       requisites: [],
       openLogin: false,
       openEnroll: false,
       pendingEnroll: false,
       pendingWaitList: false,
       waitListCourseID: 0,
       enrollCourseID: 0,
       sessionModalView: "login",
       waitlistMessage: null,
       openWaitListModal: false,
       openWaitListRemoveModal: false,
       categoriesCallback: false,
       requisitesLoaded: false,
     };
   },
   watch: {
     isLoggedIn(val) {
       if (this.pendingEnroll) {
         this.doEnroll();
       }
 
       if (this.pendingWaitList) {
         this.showWaitListModal(this.waitListCourseID);
       }
 
       this.pendingEnroll = false;
       this.pendingWaitList = false;
       if(!val) {//Clear session data
         $(document.body).data('sessionManageCalled', false);
         if(this.sessionManageCalled) { this.toggleSessionManageCalled(); }
         /**if (window.allowScripts && this.isAdmin) {
           window.Intercom("shutdown");
         }**/
         this.setUser(null);
         //this.setUserLogin({});
       }
     },
   },
   computed: {
     ...mapState(['sessionManageCalled', 'isLoggedIn', 'user', 'corporation', 'corporationInfo', 'stayAliveData']),
     isAdmin() {
       return _.get(this.user, "ACL.Course.Create", 0) === 1;
     },
     logoutUrl: function() {
       return _.get(this.corporation, 'show_oauth_login', false) && this.stayAliveData.access_token ? `https://login.apprendo.io/v2/logout?returnTo=${encodeURIComponent(`${window.location.protocol}//${window.location.hostname}/aprendo/logout?redirect_url=${window.location.pathname}`)}&client_id=${this.stayAliveData.client_id}` : `/aprendo/logout?redirect_url=${window.location.pathname}`;
     },
     menuTopFilters() {
      let menuTopFilters = _.get(this.corporation, 'menu_top_filters', null);
      return menuTopFilters ? JSON.parse(menuTopFilters) : {};
     },
     showCategoriesMenu() {
      return Object.values(this.menuTopFilters).indexOf(true) > -1;
    },
    skipCategoriesWait() {
      return !Object.values(this.$route.params).length;
    },
    categoriesLoadAllowed() {
      return !this.$route.name && (this.$route.fullPath === '/' || this.$route.params.hasOwnProperty('category'));
    },
   },
   methods: {
     ...mapMutations(["setUserLogin", 'toggleSessionManageCalled', 'setIsLoggedIn', 'setUser', 'setCorporation', 'setCorporationInfo', 'setStayAliveData', 'setHasEnroll', 'setCategories', 'resetCategories']),
 
     async loadCorporationData() {
       let loader = this.$loading.show();
       await this.doCorporationRequest();
       loader.hide();
     },
     async doCorporationRequest() {
       const apiResponse = await API.main.getCorporationData({
         domain: window.DOMAIN,
         catalogue_path: CATALOGUE_PATH,
       });
       this.setCorporation(Object.assign({}, _.get(apiResponse, "data.configuration", {}), { serverTimezone: _.get(apiResponse, "data.serverTimezone", moment.tz.guess()) }));
       //this.corporation = _.get(apiResponse, "data.configuration", {});
       this.setCorporationInfo(_.get(apiResponse, "data.corporation", {}));
       //this.corporationInfo = _.get(apiResponse, "data.corporation", {});
       this.gatherCategories();
     },
     async gatherCategories() {
      if(this.showCategoriesMenu && this.categoriesLoadAllowed) { //Only loads for non-dashboard
        if(this.skipCategoriesWait) this.categoriesCallback = true;
          let categoryTypes = [];
          if(CATALOGUE_PATH){
            categoryTypes.push(CATEGORIES_TYPES.CATEGORY);
            categoryTypes.push(CATEGORIES_TYPES.HOST);
            categoryTypes.push(CATEGORIES_TYPES.COMPETENCES);
          }
          else{
            if(this.menuTopFilters.category) categoryTypes.push(CATEGORIES_TYPES.CATEGORY);
            if(this.menuTopFilters.host) categoryTypes.push(CATEGORIES_TYPES.HOST);
            if(this.menuTopFilters.competences) categoryTypes.push(CATEGORIES_TYPES.COMPETENCES);
            if(this.menuTopFilters.formats && this.corporationInfo.id_corporation === 298) categoryTypes.push(CATEGORIES_TYPES.FORMATS);
          }
          
          const categories = await API.domain.getCategories({
              filters: {
                  id_corporation: this.corporationInfo.id_corporation,
                  catalogue_path: CATALOGUE_PATH ? CATALOGUE_PATH : "",
                  types: JSON.stringify(categoryTypes),
                  is_active: 1,
              },
          });
          this.resetCategories();
          categoryTypes.forEach(categoryType=>this.setCategories([categoryType, categories.data.data.filter(c=>c.id_category_type === categoryType && c.active)]));
      } else {
          this.resetCategories();
      }
      this.categoriesCallback = true;
    },
     trulyStayAlive() {
       var This = this;
 
       setTimeout(function() {
         const apiResponse = API.phpAppEndpoints.stayAlive();
         This.trulyStayAlive();
       }, 20000);
     },
     async stayAlive() {
       const apiResponse = await API.phpAppEndpoints.stayAlive();
       this.setIsLoggedIn(!!apiResponse.data.token_api);
       //this.isLoggedIn = !!apiResponse.data.token_api;
       this.setStayAliveData(apiResponse.data);
       if (this.isLoggedIn) {
         localStorage.setItem("token", apiResponse.data.token_api);
         if($(document.body).data('sessionManageCalled') && !this.user) { //If it's already called
           const userResponse = await API.main.getUser();
           this.setUser(userResponse.data);
           //this.setUserLogin(userResponse.data);
           //this.user = userResponse.data;
           /**if (window.allowScripts && this.isAdmin) {
             window.Intercom("boot", {
               app_id: "ypty6beg",
               name: this.user.first_name + " " + this.user.last_name, // Full name
               email: this.user.email, // Email address
               created_at: new Date().getTime(), // Signup date
             });
           }**/
         }
       } else {
         localStorage.removeItem("token");
         localStorage.removeItem("lastSeenCourses");
         localStorage.removeItem("lastSeenUsers");
         localStorage.removeItem("lastSeenCatalogues");
         localStorage.removeItem("lastSeenForms");
         localStorage.removeItem("lastSearchedCourses");
         localStorage.removeItem("lastSearchedUsers");
         localStorage.removeItem("lastSearchedCatalogues");
         localStorage.removeItem("lastSearchedForms");
 
         /**if (window.allowScripts && this.isAdmin) {
           window.Intercom("shutdown");
         }**/
       }
     },
     enroll(courseId) {
       this.enrollCourseID = courseId;
       if (this.isLoggedIn) {
         this.doEnroll(courseId);
       } else {
         this.setHasEnroll(true);
         this.pendingEnroll = true;
         this.openLoginDialog();
       }
     },
     addToWaitListOpen(course) {
      if(!this.isLoggedIn) {
        this.openLoginDialog();
        return;
      }
       //waitlist enable validation
       if(typeof this.showWaitListFunc === 'function' ? this.showWaitListFunc(course) : this.showWaitList(course)){
        let loader = this.$loading.show();
         API.checkoutProcess
           .getSeats(this.course.id)
           .then((apiResponse) => {     
             let response = apiResponse.data;       
             this.seats = response.data;
             this.waitlistCount = response.waitlistCount;
             //seat waitlist validation     
             if(this.seats && this.seats.length == 1){
               let seatItem =  this.seats[0];
               let isRestrected = !this.isAOorCMIC && seatItem.authorized_domains && seatItem.authorized_domains.split(',').filter(authorized_domain=>/\w+\.\w+(\.\w+)*/.test(authorized_domain.trim())).find(authorized_domain=>authorized_domain.trim().toLowerCase() === this.user.email.split('@')[1].trim().toLowerCase()) === undefined;
               if(!isRestrected){
                 this.seatSelected = seatItem;              
                 this.waitListCourseID = course.id;
                 this.showDialog = false;
                 this.openDialog = true; 
               }
               else{
                 this.showDialog = true;
               }
              }
              else{
                this.showDialog = true;
              }
              loader.hide();
           });
       }
       else{
         this.enroll(course.id);
         // this.openWaitListModal = true;
         // this.pendingWaitList = false;
         // this.waitListCourseID = course.id;
       }     
     },
     showWaitList(course){
       console.log("eSTO TIENE EL COURSE:: ",course);
       console.log("esto tiene el course.waitlistActive: ", course.waitlistActive);
       // return true;
       if(course.hasOwnProperty('is_coming_soon') && course.is_coming_soon == 1) {               
         return false;
       }
 
       if(course.user_in_course == 1){               
         return false
       }
       
       if(course.wait_list_type === 'FORCE' && !course.user_in_wait_list){               
             return true;
       }

       return (course.soldout || !!course.current_users) && !course.user_in_wait_list && ((course.wait_list_type === 'ENABLED' && course.max_num_waiters > course.current_users) || course.wait_list_type === 'AUTO' || !course.wait_list_type === 'FORCE');
       
     },
     addToWaitList(courseId,id_course_seat_type, name,seat_name) {
       if (this.isLoggedIn) {
         this.showWaitListModal(courseId,id_course_seat_type, name, seat_name);
       } else {
         this.pendingWaitList = true;
         this.waitListCourseID = courseId;
         this.openLoginDialog();
       }
     },
     removeFromWaitList(courseId) {
       console.log("quelqua");
 
       this.openWaitListRemoveModal = true;
       this.pendingWaitList = false;
       this.waitListCourseID = courseId;
     },
     async showWaitListModal(courseId,id_course_seat_type, id_course_seat, seat_name) {
      console.log("Esto trae seat_name: ", seat_name);
       let loader = this.$loading.show();
       // this.enroll(courseId);
       const apiResponse = await API.main.addToWaitList(courseId,id_course_seat_type,id_course_seat,seat_name);
       this.$emit("refresh");
       if(typeof this.changeWaitlist === 'function') { this.changeWaitlist(true,id_course_seat); }
       this.waitlistMessage = apiResponse.data.message;
       this.openWaitListModal = false;
       loader.hide();
     },
     openLoginDialog() {
       //if(this.corporation.oauth_login == 1) {
       if(_.get(this.corporation, 'show_oauth_login', false)) {
         const returnUrl = encodeURIComponent(window.location.href);
         window.location.assign(window.location.protocol + '//' + window.location.hostname + '/aprendo/oauth0?returnUrl=' + returnUrl);
       } else {
         this.sessionModalView = "login";
         this.openLogin = !this.openLogin;
       }
     },
     openSignUpDialog() {
       this.sessionModalView = "signUp";
       this.openLogin = !this.openLogin;
     },
     async getRequisites(courseId) {
      if(!courseId || this.requisitesLoaded || !this.isLoggedIn) return;
      let apiResponse = null;
      let retries = 0;
      const maxRetries = 5;
      while (retries < maxRetries) {
        try {
          apiResponse = await API.course.getRequisites({
            courseId: courseId,
          });
          if (
            apiResponse &&
            apiResponse.data &&
            Array.isArray(apiResponse.data.data)
          ) {
            break; // ok
          } else {
            throw new Error('Requisites data malformed');
          }
        } catch (err) {
          retries++;
          if (retries >= maxRetries) {
            console.error("Failed to fetch requisites for course:", courseId, err);
            apiResponse = { data: { data: [] } }; // fallback
          }
        }
      }
      this.requisites = apiResponse.data.data.map((requisite) => {
        if (requisite.meta === "checkbox" || requisite.meta === "text") {
          requisite.text = requisite.requisite;
          requisite.value = null;
        } else if (requisite.meta === "selectbox") {
          requisite.text = requisite.requisite;
          requisite.options = requisite.value.split(",");
          requisite.value = requisite.options[0];
        } else if (requisite.meta !== "html") {
          requisite.value = null;
        }

        return requisite;
      });
      this.requisitesLoaded = true;
     },
     async doEnroll(courseIdParam) {
       if (courseIdParam) {
         this.enrollCourseID = courseIdParam;
       }
 
       // GEt requisites
       await this.getRequisites(this.enrollCourseID);
       if (this.requisitesLoaded && !!this.requisites.length) {
         // Show modal
         this.openEnroll = !this.openEnroll;
       } else {
        if(this.isPath) {
          window.open(CATALOGUE_PATH && CATALOGUE_PATH!="/marketplace/index/"
           ? CATALOGUE_PATH + "checkout/" + this.enrollCourseID
           : PAGES.CHECKOUT + this.enrollCourseID, '_blank');
        } else {
          window.location.href = CATALOGUE_PATH && CATALOGUE_PATH!="/marketplace/index/"
           ? CATALOGUE_PATH + "checkout/" + this.enrollCourseID
           : PAGES.CHECKOUT + this.enrollCourseID;
        }
         //window.location.href = PAGES.CHECKOUT + this.enrollCourseID;
       }
     },
     updateAccessToken: function(access_token, client_id) {
       $(this.$root.$el).data('access_token', access_token);
       $(this.$root.$el).data('client_id', client_id);
       console.log('updateAccessToken');
       this.setCorporation(this.corporation);
       this._computedWatchers.accessToken.run();
       this._computedWatchers.clientId.run();
       this._computedWatchers.logoutUrl.run();
     },
   },
   async created() {
     if(!$(document.body).data('sessionManageCalled')) {
       $(document.body).data('sessionManageCalled', true);
       if(this.sessionManageCalled) { this.toggleSessionManageCalled(); }
     }
     if(!this.sessionManageCalled) {
       $(document.body).data('sessionManageCalled', true);
       this.toggleSessionManageCalled();
       if (
         _.get(this.$route, "query.username", null) &&
         _.get(this.$route, "query.api_token", null)
       ) {
         API.phpAppEndpoints
           .processLogin({
             username: this.$route.query.username,
             api_token: this.$route.query.api_token,
           })
           .then( async() => {
             await this.stayAlive();
             this.loadCorporationData();
           });
       } else {
         await this.stayAlive();
         this.loadCorporationData();
       }
     }
   },
 };
 